"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isFile(file) {
  return typeof File !== 'undefined' && file instanceof File || typeof Blob !== 'undefined' && file instanceof Blob;
}
exports.default = isFile;